import React from 'react'
import {Button, Popconfirm} from "antd";
import {dispatchOutgoing} from "../../../services/serviceWarehouseOutgoing";

const ConfirmDispatch = ({record, reloader}) => {

    const handleConfirm = () => {
        dispatchOutgoing(record.id)
            .then(() => reloader())
    }

    return(
        <React.Fragment>
            <Popconfirm title={'Çıkış Yapmak istediğinizden emin misiniz ?'}
                onConfirm={handleConfirm}
            >
                <Button
                    style={{marginLeft: '-10px'}}
                    type={'link'}
                    disabled={record.shipmentStatus !== 'WAITING'}
                >
                    Çıkış Yap
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default ConfirmDispatch